import { useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

import UseHostedCheckoutV2 from './useHostedPaymentCheckoutV2';
import usePaymentLink from '../paymentLink/usePaymentLink';
import UTILS from '../../common/utils';
import { PaymentMethodType } from '../../common/constants';
import CardDetailsForm from './cardDetailsForm';
import Wallet from './wallet';
import CheckoutView from './checkoutView';
import LoadingView from '../loadingView';

const HostedPaymentCheckoutV2 = () => {
    const [isPaymentDataValid, setIsPaymentDataValid] = useState(false);

    const paymentDataRef = useRef({});

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const sessionId = searchParams.get('session_id');

    const handlePaymentDataChange = (field, value) => {
        paymentDataRef.current[field] = value;
        setIsPaymentDataValid(UTILS.ValidateFormData(paymentDataRef.current, sessionInfo.payment_method_type));
    };

    const getIdFromToken = (token) => {
        const decoded = jwtDecode(token);
        return decoded.unique_name;
    }

    const { sessionInfo, merchantName, isFetchingSessionInfo } = UseHostedCheckoutV2(token, sessionId);
    const { submitPayment, isPaying, merchantLogo } = usePaymentLink(null, null, getIdFromToken(token));

    const onSubmit = async () => {
        const failUrl = sessionInfo.failure_url;
        const paymentSession = { token, sessionId, failUrl };
        await submitPayment(
            paymentSession,
            paymentDataRef.current,
            sessionInfo.payment_method_type,
            merchantName,
            sessionInfo.is_3ds_required,
        );
    }

    const getPaymentMethodComponent = () => {
        switch (sessionInfo.payment_method_type) {
            case PaymentMethodType.BankCard:
                return <CardDetailsForm 
                    handleChange={handlePaymentDataChange}
                    isSaveCardOptionEnabled={sessionInfo.is_save_card_checkbox_enabled}
                    isCVVRequired={sessionInfo.is_cvv_required} />
            case PaymentMethodType.Wallet:
                return <Wallet handleChange={handlePaymentDataChange} />
            default:
                return <></>
        }
    }

    const getTitle = () => {
        switch (sessionInfo.payment_method_type) {
            case PaymentMethodType.BankCard:
                return "Enter card details";
            case PaymentMethodType.Wallet:
                return "Enter your wallet number";
            default:
                return "";
        }
    }

    return (
        isFetchingSessionInfo ? <LoadingView color='#4055FF' /> :
        <CheckoutView
            onSubmit={onSubmit} 
            isButtonLoading={isPaying}
            isAllFieldsValid={isPaymentDataValid}
            buttonLabel="Pay"
            merchantLogo={merchantLogo}
            title={getTitle()}>
            {getPaymentMethodComponent()}
        </CheckoutView>
    );

}

export default HostedPaymentCheckoutV2;